module.exports = __webpack_public_path__ + "static/media/parceiro-txfiber.91e98d2c.jp2";